module.exports = __webpack_public_path__ + "img/2.159e47eb.png";